import React from "react";
import Modal from "react-bootstrap/Modal";
import { IoClose } from "react-icons/io5";

const ModalPreview = ({ show, handleClose, image }) => {
  return (
    <>
      {show && (
        <IoClose
          color="#FFFF"
          className="close-btn"
          size={30}
          onClick={handleClose}
        />
      )}
      <Modal size="xl" centered show={show} onHide={handleClose}>
        <img src={image.img} alt="preview" />
        <div className="text-white text-center text-lg fw-bold">
          {image.title}
        </div>
      </Modal>
    </>
  );
};

export default ModalPreview;
